import { useMutation } from '@tanstack/react-query';
import type { UseMutateFunction } from '@tanstack/react-query';
import { useMessage } from './useMessage';
import { getFilePresignedUrlApi } from './useInteractDownloadFile';

export const GET_INTERACT_FILE_VIEW_URL_KEY = 'getInteractFileViewUrl';

interface IViewFileParams {
  fileId: string;
}

export const useViewInteractFile = (onSuccess?: (url: string) => void) => {
  const message = useMessage();

  const {
    mutate,
    isPending: isLoadingFile,
    error: errorLoadingFile,
  } = useMutation<string, Error, IViewFileParams>({
    mutationKey: [GET_INTERACT_FILE_VIEW_URL_KEY],
    mutationFn: ({ fileId }) => getFilePresignedUrlApi(fileId),
    onSuccess: url => {
      if (onSuccess) {
        onSuccess(url);
      }
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.title ||
        error?.message ||
        'Failed to load file';
      message.error(errorMessage);
    },
  });

  const viewFile: UseMutateFunction<string, Error, IViewFileParams, unknown> =
    mutate;

  return {
    viewFile,
    isLoadingFile,
    errorLoadingFile,
  };
};
